module.exports = __webpack_public_path__ + "static/deep-understanding-mobile-50af2efd0c5edf1e34803b519d02663b.webp";